/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_Multiview_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close split multiview group dialog" |
*
* @param {Split_Multiview_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_close_aria_label = /** @type {((inputs?: Split_Multiview_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boîte de dialogue de groupe multivue fractionnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen des Dialogs „Geteilte Multiview-Gruppe“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra di dialogo del gruppo multivista diviso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть диалоговое окно группы с разделенным многоэкранным режимом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar cuadro de diálogo de grupo multivista dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭拆分多视图组对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割マルチビューグループダイアログを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्प्लिट मल्टीव्यू ग्रुप डायलॉग बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar caixa de diálogo de grupo multivisualização dividido")
	return /** @type {LocalizedString} */ ("Close split multiview group dialog")
});